<template>
    <div>
        <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                               :titleLabel="$t('profile.label.existence_benefic_owner')"
                               :parentScreen="parentScreen">
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner')}}</label>
                <div class="col-md-6">
                    <div class="form-check form-check-inline" v-for="beneficOwner in listBeneficOwner"
                         :key="beneficOwner.key">
                        <input class="form-check-input"
                               type="radio"
                               name="inlineRadioOptions"
                               :id="'inlineRadioOptions_'+beneficOwner.value"
                               v-model="$v.input['amsCustomerDetail.beneficOwnerFlg'].$model"
                               :value="beneficOwner.key"
                               :disabled="isDisabledRadio(beneficOwner.key)"
                        >
                        <label class="form-check-label" :for="beneficOwner.value">{{beneficOwner.value}}</label>
                    </div>
                </div>
            </div>
            <div class="benefic-info" v-if="input['amsCustomerDetail.beneficOwnerFlg'] === '1'">
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label" style="font-weight: bold;">{{$t('profile.benefic.label.title.1')}}</label>
                </div>
                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_type')}}</label>
                    <div class="col-md-6">
                        <div class="form-check form-check-inline" v-for="beneficOwnertype in listBeneficOwnerType" :key="beneficOwnertype.key">
                            <input class="form-check-input"
                                   type="radio"
                                   name="inlineRadioTypeOptions"
                                   :id="'inlineRadioTypeOptions_'+ beneficOwnertype.value"
                                   v-model="$v.input['amsCustomerDetail.beneficOwnerType'].$model"
                                   :value="beneficOwnertype.key"
                            >
                          <label class="form-check-label" :for="beneficOwnertype.value">{{beneficOwnertype.value}}</label>
                        </div>
                      <div v-if="$v.input['amsCustomerDetail.beneficOwnerType'].$dirty && $v.input['amsCustomerDetail.beneficOwnerType'].$anyError"
                           class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.beneficOwnerType'].beneficOwnerTypeRequiredValidation">
                          {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_type') })}}
                        </div>
                      </div>
                    </div>
                </div>

               <template v-if="input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED">
                 <template v-if="(this.isOldBeneficOwner('') || input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL)">
                   <div class="form-group row">
                     <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name')}}</label>
                     <div class="col-md-6">
                       <template v-if="isVisible">
                         <input type="text"
                                class="form-control"
                                value="*****"
                                name="beneficOwnerLastName"
                                required
                                maxlength="40"
                                v-convert-halfwidth-to-fullwidth>
                       </template>
                       <template v-else>
                         <input type="text"
                                class="form-control"
                                v-model="$v.input['amsCustomerDetail.beneficOwnerLastName'].$model"
                                name="beneficOwnerLastName"
                                required
                                maxlength="40"
                                v-convert-halfwidth-to-fullwidth>
                       </template>
                       <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastName'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastName'].$anyError" class="error-messages ng-active">
                         <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastName'].required">
                           {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name') })}}
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="form-group row">
                     <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name')}}</label>
                     <div class="col-md-6">
                       <div v-if="isVisible">
                         <input type="text"
                                class="form-control"
                                value="*****"
                                name="beneficOwnerFirstName"
                                required
                                maxlength="40"
                                v-convert-halfwidth-to-fullwidth>
                       </div>
                       <div v-else>
                         <input type="text"
                                class="form-control"
                                v-model="$v.input['amsCustomerDetail.beneficOwnerFirstName'].$model"
                                name="beneficOwnerFirstName"
                                required
                                maxlength="40"
                                v-convert-halfwidth-to-fullwidth>
                       </div>
                       <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstName'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstName'].$anyError"
                            class="error-messages ng-active">
                         <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstName'].required">
                           {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name') })}}
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="form-group row">
                     <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name_kana')}}</label>
                     <div class="col-md-6">
                       <template v-if="isVisible">
                         <input type="text"
                                class="form-control"
                                value="*****"
                                name="beneficOwnerLastNameKana"
                                required
                                maxlength="40"
                                v-special-characters-validator
                                v-convert-kana-word>
                       </template>
                       <template v-else>
                         <input type="text"
                                class="form-control"
                                v-model="$v.input['amsCustomerDetail.beneficOwnerLastNameKana'].$model"
                                name="beneficOwnerLastNameKana"
                                required
                                maxlength="40"
                                v-special-characters-validator
                                v-convert-kana-word>
                       </template>
                       <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastNameKana'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastNameKana'].$anyError"
                            class="error-messages ng-active">
                         <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastNameKana'].required">
                           {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name_kana') })}}
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="form-group row">
                     <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name_kana')}}</label>
                     <div class="col-md-6">
                       <template v-if="isVisible">
                         <input type="text"
                                class="form-control"
                                value="*****"
                                name="beneficOwnerFirstNameKana"
                                required
                                maxlength="40"
                                v-special-characters-validator
                                v-convert-kana-word>
                       </template>
                       <template v-else>
                         <input type="text"
                                class="form-control"
                                v-model="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana'].$model"
                                name="beneficOwnerFirstNameKana"
                                required
                                maxlength="40"
                                v-special-characters-validator
                                v-convert-kana-word>
                       </template>
                       <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstNameKana'].$anyError"
                            class="error-messages ng-active">
                         <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstNameKana'].required">
                           {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name_kana') })}}
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="form-group row">
                     <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_establish_date')}}</label>
                     <div class="col-md-6">
                       <template v-if="isVisible">
                         <input type="text" value="****/**/**" class="form-control">
                         <span class="btn-datepicker">
                                	<i class="icon-calendar icons"/>
                            	</span>
                       </template>
                       <template v-else>
                         <trs-date-picker :hasIcon="true" v-model="$v.input['amsCustomerDetail.beneficOwnerEstablishDate'].$model"/>
                       </template>

                       <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate'].$dirty && $v.input['amsCustomerDetail.beneficOwnerEstablishDate'].$anyError" class="error-messages ng-active">
                         <div v-if="!$v.input['amsCustomerDetail.beneficOwnerEstablishDate'].required">
                           {{$t('MSG_TRS_NAF_0126')}}
                         </div>
                         <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate'].required && !$v.input['amsCustomerDetail.beneficOwnerEstablishDate'].validDate">
                           <div>{{$t('MSG_TRS_NAF_0126')}}</div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </template>
              </template>
              <template v-else>
                  <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name')}}</label>
                    <div class="col-md-6">
                      <template v-if="isVisible">
                        <input type="text"
                               class="form-control"
                               value="*****"
                               name="beneficOwnerFullname"
                               required
                               maxlength="40"
                               v-convert-halfwidth-to-fullwidth>
                      </template>
                      <template v-else>
                        <input type="text"
                               class="form-control"
                               v-model="$v.input['amsCustomerDetail.beneficOwnerFullname'].$model"
                               name="beneficOwnerFullname"
                               required
                               maxlength="40"
                               v-convert-halfwidth-to-fullwidth>
                      </template>
                      <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullname'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullname'].$anyError"
                           class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullname'].required">
                          {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name') })}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name_kana')}}</label>
                    <div class="col-md-6" >
                      <template v-if="isVisible">
                        <input type="text"
                               class="form-control"
                               value="*****"
                               name="beneficOwnerFullnameKana"
                               required
                               v-special-characters-validator
                               maxlength="40"
                               v-convert-kana-word
                        >
                      </template>
                      <template v-else>
                        <input type="text"
                               class="form-control"
                               v-model="$v.input['amsCustomerDetail.beneficOwnerFullnameKana'].$model"
                               name="beneficOwnerFullnameKana"
                               required
                               v-special-characters-validator
                               maxlength="40"
                               v-convert-kana-word
                        >
                      </template>
                      <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullnameKana'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullnameKana'].$anyError"
                           class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullnameKana'].required">
                          {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name_kana') })}}
                        </div>
                      </div>
                    </div>
                  </div>
              </template>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_zipcode' )}}</label>
                    <div class="col-md-6">
                        <div v-if="isVisible">
                            <input type="text"
                                   class="form-control"
                                   value="*****"
                                   name="beneficOwnerZipcode"
                                   required
                                   maxlength="7"
                                   v-convert-fullwidth-to-halfwidth>

                        </div>
                        <div v-else>
                            <input type="text"
                                   class="form-control"
                                   v-model="$v.input['amsCustomerDetail.beneficOwnerZipcode'].$model"
                                   name="beneficOwnerZipcode"
                                   @blur="searchZipCode('amsCustomerDetail.beneficOwnerZipcode',
                                                    'amsCustomerDetail.beneficOwnerPrefecture',
                                                    'amsCustomerDetail.beneficOwnerCity')"
                                   required
                                   maxlength="7"
                                   v-convert-fullwidth-to-halfwidth>
                        </div>

                        <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode'].$dirty && $v.input['amsCustomerDetail.beneficOwnerZipcode'].$anyError" class="error-messages ng-active">
                            <div v-if="!$v.input['amsCustomerDetail.beneficOwnerZipcode'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_zipcode' )})}}
                            </div>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode'].required && !$v.input['amsCustomerDetail.beneficOwnerZipcode'].customerNumberValidation">
                                {{$t('profile.error.invalid_number')}}
                            </div>
                        </div>
                    </div>
                    <label class="col-md-3">
                        <a :href="hrefPostalCodeReference" target="_blank">{{$t('profile.href.postal_code_reference')}}</a>
                    </label>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_prefecture')}}</label>
                    <div class="col-md-6">
                        <select v-if="isVisible" class="form-control">
                            <option selected>*****</option>
                        </select>
                        <select
                            v-else
                            class="form-control"
                            v-model="$v.input['amsCustomerDetail.beneficOwnerPrefecture'].$model"
                            required
                            name="beneficOwnerPrefecture"
                        >
                            <option v-for="item in listPrefecture" :key="item.key" :value="item.key">
                                {{item.value}}
                            </option>
                        </select>
                        <div v-if="$v.input['amsCustomerDetail.beneficOwnerPrefecture'].$dirty && $v.input['amsCustomerDetail.beneficOwnerPrefecture'].$anyError" class="error-messages ng-active">
                            <div v-if="!$v.input['amsCustomerDetail.beneficOwnerPrefecture'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_prefecture' )})}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_city')}}</label>
                    <div class="col-md-6">
                        <template v-if="isVisible">
                            <input type="text"
                                   class="form-control"
                                   value="*****"
                                   name="beneficOwnerCity"
                                   required
                                   maxlength="100"
                                   v-convert-halfwidth-to-fullwidth
                            >
                        </template>
                        <template v-else>
                            <input type="text"
                                   class="form-control"
                                   v-model="$v.input['amsCustomerDetail.beneficOwnerCity'].$model"
                                   name="beneficOwnerCity"
                                   required
                                   maxlength="100"
                                   v-convert-halfwidth-to-fullwidth
                            >
                        </template>
                        <div v-if="$v.input['amsCustomerDetail.beneficOwnerCity'].$dirty && $v.input['amsCustomerDetail.beneficOwnerCity'].$anyError" class="error-messages ng-active">
                            <div v-if="!$v.input['amsCustomerDetail.beneficOwnerCity'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_city' )})}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_section')}}</label>
                    <div class="col-md-6">
                        <template v-if="isVisible">
                            <input type="text"
                                   class="form-control"
                                   value="*****"
                                   name="beneficOwnerSection"
                                   required
                                   maxlength="50"
                                   v-convert-halfwidth-to-fullwidth
                            >
                        </template>
                        <template v-else>
                            <input type="text"
                                   class="form-control"
                                   v-model="$v.input['amsCustomerDetail.beneficOwnerSection'].$model"
                                   name="beneficOwnerSection"
                                   required
                                   maxlength="50"
                                   v-convert-halfwidth-to-fullwidth
                            >
                        </template>
                        <div v-if="$v.input['amsCustomerDetail.beneficOwnerSection'].$dirty && $v.input['amsCustomerDetail.beneficOwnerSection'].$anyError" class="error-messages ng-active">
                            <div v-if="!$v.input['amsCustomerDetail.beneficOwnerSection'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owener_section' )})}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_building_name')}}</label>
                    <div class="col-md-6">
                        <template v-if="isVisible">
                            <input type="text" class="form-control"
                                   value="*****"
                                   name="beneficOwnerBuildingName"
                                   maxlength="50"
                                   v-convert-halfwidth-to-fullwidth
                            >
                        </template>
                        <template v-else>
                            <input type="text" class="form-control"
                                   v-model.trim="$v.input['amsCustomerDetail.beneficOwnerBuildingName'].$model"
                                   name="beneficOwnerBuildingName"
                                   maxlength="50"
                                   v-convert-halfwidth-to-fullwidth
                            >
                        </template>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner2')}}</label>
                    <div class="col-md-6">
                        <div class="form-check form-check-inline" v-for="beneficOwner in listBeneficOwnerOtherOne" :key="beneficOwner.key">
                            <input class="form-check-input"
                                   type="radio"
                                   name="inlineRadioOptions_2"
                                   :id="'inlineRadioOptions_2'+beneficOwner.key"
                                   v-model="$v.input['amsCustomerDetail.beneficOwnerFlg2'].$model"
                                   :value="beneficOwner.key"
                            >
                            <label class="form-check-label" :for="beneficOwner.value">{{beneficOwner.value}}</label>
                        </div>
                    </div>
                </div>

                <div class="benefic-info" v-if="input['amsCustomerDetail.beneficOwnerFlg2'] === '1'">
                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label" style="font-weight: bold;">{{$t('profile.benefic.label.title.2')}}</label>
                    </div>
                    <div class="form-group row">
                    <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_type')}}</label>
                    <div class="col-md-6">
                      <div class="form-check form-check-inline" v-for="beneficOwnertype in listBeneficOwnerType"
                           :key="beneficOwnertype.key">
                        <input class="form-check-input"
                               type="radio"
                               name="inlineRadioType2Options"
                               :id="'inlineRadioType2Options_' + beneficOwnertype.value"
                               v-model="$v.input['amsCustomerDetail.beneficOwnerType2'].$model"
                               :value="beneficOwnertype.key"
                        >
                        <label class="form-check-label" :for="beneficOwnertype.value">{{beneficOwnertype.value}}</label>
                      </div>
                      <div v-if="$v.input['amsCustomerDetail.beneficOwnerType2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerType2'].$anyError"
                           class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.beneficOwnerType2'].beneficOwnerTypeRequiredValidation">
                          {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_type') })}}
                        </div>
                      </div>
                    </div>
                  </div>

                    <template v-if="input['amsCustomerDetail.beneficOwnerType2'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || input['amsCustomerDetail.beneficOwnerType2'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED">
                      <template v-if="(this.isOldBeneficOwner('2') || input['amsCustomerDetail.beneficOwnerType2'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL)">
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerLastName2"
                                     required
                                     maxlength="40"
                                     v-convert-halfwidth-to-fullwidth>
                            </template>
                            <template v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerLastName2'].$model"
                                     name="beneficOwnerLastName2"
                                     required
                                     maxlength="40"
                                     v-convert-halfwidth-to-fullwidth>
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastName2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastName2'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastName2'].required">
                                {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name') })}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name')}}</label>
                          <div class="col-md-6">
                            <div v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerFirstName2"
                                     required
                                     maxlength="40"
                                     v-convert-halfwidth-to-fullwidth>
                            </div>
                            <div v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerFirstName2'].$model"
                                     name="beneficOwnerFirstName2"
                                     required
                                     maxlength="40"
                                     v-convert-halfwidth-to-fullwidth>
                            </div>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstName2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstName2'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstName2'].required">
                                {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name') })}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name_kana')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerLastNameKana2"
                                     required
                                     maxlength="40"
                                     v-special-characters-validator
                                     v-convert-kana-word>
                            </template>
                            <template v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerLastNameKana2'].$model"
                                     name="beneficOwnerLastNameKana"
                                     required
                                     maxlength="40"
                                     v-special-characters-validator
                                     v-convert-kana-word>
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastNameKana2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastNameKana2'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastNameKana2'].required">
                                {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name_kana') })}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name_kana')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerFirstNameKana2"
                                     required
                                     maxlength="40"
                                     v-special-characters-validator
                                     v-convert-kana-word>
                            </template>
                            <template v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana2'].$model"
                                     name="beneficOwnerFirstNameKana2"
                                     required
                                     maxlength="40"
                                     v-special-characters-validator
                                     v-convert-kana-word>
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstNameKana2'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstNameKana2'].required">
                                {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name_kana') })}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_establish_date')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text" value="****/**/**" class="form-control">
                              <span class="btn-datepicker">
                                        <i class="icon-calendar icons"/>
                                     </span>
                            </template>
                            <template v-else>
                              <trs-date-picker :hasIcon="true" v-model="$v.input['amsCustomerDetail.beneficOwnerEstablishDate2'].$model"/>
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerEstablishDate2'].$anyError" class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerEstablishDate2'].required">
                                {{$t('MSG_TRS_NAF_0126')}}
                              </div>
                              <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate2'].required && !$v.input['amsCustomerDetail.beneficOwnerEstablishDate2'].validDate">
                                <div>{{$t('MSG_TRS_NAF_0126')}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name')}}</label>
                        <div class="col-md-6">
                            <template v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerFullname2"
                                       required
                                       maxlength="40"
                                       v-convert-halfwidth-to-fullwidth>
                            </template>
                            <template v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerFullname2'].$model"
                                       name="beneficOwnerFullname2"
                                       required
                                       maxlength="40"
                                       v-convert-halfwidth-to-fullwidth>
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullname2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullname2'].$anyError"
                                 class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullname2'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name') })}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name_kana')}}</label>
                        <div class="col-md-6" >
                            <template v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerFullnameKana2"
                                       required
                                       v-special-characters-validator
                                       maxlength="40"
                                       v-convert-kana-word
                                >
                            </template>
                            <template v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerFullnameKana2'].$model"
                                       name="beneficOwnerFullnameKana2"
                                       required
                                       v-special-characters-validator
                                       maxlength="40"
                                       v-convert-kana-word
                                >
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullnameKana2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullnameKana2'].$anyError" class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullnameKana2'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name_kana') })}}
                                </div>
                            </div>
                        </div>
                    </div>
                    </template>
                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_zipcode' )}}</label>
                        <div class="col-md-6">
                            <div v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerZipcode2"
                                       required
                                       maxlength="7"
                                       v-convert-fullwidth-to-halfwidth>
                            </div>
                            <div v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerZipcode2'].$model"
                                       name="beneficOwnerZipcode2"
                                       @blur="searchZipCode('amsCustomerDetail.beneficOwnerZipcode2',
                                                            'amsCustomerDetail.beneficOwnerPrefecture2',
                                                            'amsCustomerDetail.beneficOwnerCity2')"
                                       required
                                       maxlength="7"
                                       v-convert-fullwidth-to-halfwidth>
                            </div>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerZipcode2'].$anyError" class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerZipcode2'].required">
                                    {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_zipcode' )})}}
                                </div>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode2'].required && !$v.input['amsCustomerDetail.beneficOwnerZipcode2'].customerNumberValidation">
                                    {{$t('profile.error.invalid_number')}}
                                </div>
                            </div>
                        </div>
                        <label class="col-md-3">
                            <a :href="hrefPostalCodeReference" target="_blank">{{$t('profile.href.postal_code_reference')}}</a>
                        </label>
                    </div>

                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_prefecture')}}</label>
                        <div class="col-md-6">
                            <select v-if="isVisible" class="form-control">
                                <option selected>*****</option>
                            </select>
                            <select
                                v-else
                                class="form-control"
                                v-model="$v.input['amsCustomerDetail.beneficOwnerPrefecture2'].$model"
                                required
                                name="beneficOwnerPrefecture2"
                            >
                                <option v-for="item in listPrefecture" :key="item.key" :value="item.key">
                                    {{item.value}}
                                </option>
                            </select>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerPrefecture2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerPrefecture2'].$anyError" class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerPrefecture2'].required">
                                    {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_prefecture' )})}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_city')}}</label>
                        <div class="col-md-6">
                            <template v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerCity2"
                                       required
                                       maxlength="100"
                                       v-convert-halfwidth-to-fullwidth
                                >
                            </template>
                            <template v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerCity2'].$model"
                                       name="beneficOwnerCity2"
                                       required
                                       maxlength="100"
                                       v-convert-halfwidth-to-fullwidth
                                >
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerCity2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerCity2'].$anyError" class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerCity2'].required">
                                    {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_city' )})}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_section')}}</label>
                        <div class="col-md-6">
                            <template v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerSection2"
                                       required
                                       maxlength="50"
                                       v-convert-halfwidth-to-fullwidth
                                >
                            </template>
                            <template v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerSection2'].$model"
                                       name="beneficOwnerSection2"
                                       required
                                       maxlength="50"
                                       v-convert-halfwidth-to-fullwidth
                                >
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerSection2'].$dirty && $v.input['amsCustomerDetail.beneficOwnerSection2'].$anyError" class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerSection2'].required">
                                    {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owener_section' )})}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_building_name')}}</label>
                        <div class="col-md-6">
                            <template v-if="isVisible">
                                <input type="text" class="form-control"
                                       value="*****"
                                       name="beneficOwnerBuildingName2"
                                       maxlength="50"
                                       v-convert-halfwidth-to-fullwidth
                                >
                            </template>
                            <template v-else>
                                <input type="text" class="form-control"
                                       v-model.trim="$v.input['amsCustomerDetail.beneficOwnerBuildingName2'].$model"
                                       name="beneficOwnerBuildingName2"
                                       maxlength="50"
                                       v-convert-halfwidth-to-fullwidth
                                >
                            </template>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner3')}}</label>
                        <div class="col-md-6">
                            <div class="form-check form-check-inline" v-for="beneficOwner in listBeneficOwnerOtherOne" :key="beneficOwner.key">
                                <input class="form-check-input"
                                       type="radio"
                                       name="inlineRadioOptions_3"
                                       :id="'inlineRadioOptions_3'+beneficOwner.key"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerFlg3'].$model"
                                       :value="beneficOwner.key"
                                >
                                <label class="form-check-label" :for="beneficOwner.value">{{beneficOwner.value}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="benefic-info" v-if="input['amsCustomerDetail.beneficOwnerFlg3'] === '1'">
                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label" style="font-weight: bold;">{{$t('profile.benefic.label.title.3')}}</label>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_type')}}</label>
                          <div class="col-md-6">
                            <div class="form-check form-check-inline" v-for="beneficOwnertype in listBeneficOwnerType" :key="beneficOwnertype.key">
                              <input class="form-check-input"
                                     type="radio"
                                     name="inlineRadioType3Options"
                                     :id="'inlineRadioType3Options_' + beneficOwnertype.value"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerType3'].$model"
                                     :value="beneficOwnertype.key"
                              >
                              <label class="form-check-label" :for="beneficOwnertype.value">{{beneficOwnertype.value}}</label>
                            </div>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerType3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerType3'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerType3'].beneficOwnerTypeRequiredValidation">
                                {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_type') })}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <template v-if="input['amsCustomerDetail.beneficOwnerType3'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || input['amsCustomerDetail.beneficOwnerType3'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED">
                          <template v-if="(this.isOldBeneficOwner('3') || input['amsCustomerDetail.beneficOwnerType3'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL)">
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerLastName3"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </template>
                                <template v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerLastName3'].$model"
                                         name="beneficOwnerLastName3"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastName3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastName3'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastName3'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name')}}</label>
                              <div class="col-md-6">
                                <div v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerFirstName3"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </div>
                                <div v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerFirstName3'].$model"
                                         name="beneficOwnerFirstName3"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </div>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstName3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstName3'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstName3'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name_kana')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerLastNameKana3"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <template v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerLastNameKana3'].$model"
                                         name="beneficOwnerLastNameKana"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastNameKana3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastNameKana3'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastNameKana3'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name_kana') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name_kana')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerFirstNameKana3"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <template v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana3'].$model"
                                         name="beneficOwnerFirstNameKana3"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstNameKana3'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstNameKana3'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name_kana') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_establish_date')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text" value="****/**/**" class="form-control">
                                  <span class="btn-datepicker">
                                         <i class="icon-calendar icons"/>
                                      </span>
                                </template>
                                <template v-else>
                                  <trs-date-picker :hasIcon="true" v-model="$v.input['amsCustomerDetail.beneficOwnerEstablishDate3'].$model"/>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerEstablishDate3'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerEstablishDate3'].required">
                                    {{$t('MSG_TRS_NAF_0126')}}
                                  </div>
                                  <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate3'].required && !$v.input['amsCustomerDetail.beneficOwnerEstablishDate3'].validDate">
                                    <div>{{$t('MSG_TRS_NAF_0126')}}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name')}}</label>
                            <div class="col-md-6">
                                <template v-if="isVisible">
                                    <input type="text"
                                           class="form-control"
                                           value="*****"
                                           name="beneficOwnerFullname3"
                                           required
                                           maxlength="40"
                                           v-convert-halfwidth-to-fullwidth>
                                </template>
                                <template v-else>
                                    <input type="text"
                                           class="form-control"
                                           v-model="$v.input['amsCustomerDetail.beneficOwnerFullname3'].$model"
                                           name="beneficOwnerFullname3"
                                           required
                                           maxlength="40"
                                           v-convert-halfwidth-to-fullwidth>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullname3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullname3'].$anyError"
                                     class="error-messages ng-active">
                                    <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullname3'].required">
                                        {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name') })}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name_kana')}}</label>
                            <div class="col-md-6">
                                <template v-if="isVisible">
                                    <input type="text"
                                           class="form-control"
                                           value="*****"
                                           name="beneficOwnerFullnameKana3"
                                           required
                                           v-special-characters-validator
                                           maxlength="40"
                                           v-convert-kana-word
                                    >
                                </template>
                                <template v-else>
                                    <input type="text"
                                           class="form-control"
                                           v-model="$v.input['amsCustomerDetail.beneficOwnerFullnameKana3'].$model"
                                           name="beneficOwnerFullnameKana3"
                                           required
                                           v-special-characters-validator
                                           maxlength="40"
                                           v-convert-kana-word
                                    >
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullnameKana3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullnameKana3'].$anyError"
                                     class="error-messages ng-active">
                                    <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullnameKana3'].required">
                                        {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name_kana')})}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </template>
                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_zipcode')}}</label>
                            <div class="col-md-6">
                                <div v-if="isVisible">
                                    <input type="text"
                                           class="form-control"
                                           value="*****"
                                           name="beneficOwnerZipcode3"
                                           required
                                           maxlength="7"
                                           v-convert-fullwidth-to-halfwidth>
                                </div>
                                <div v-else>
                                    <input type="text"
                                           class="form-control"
                                           v-model="$v.input['amsCustomerDetail.beneficOwnerZipcode3'].$model"
                                           name="beneficOwnerZipcode3"
                                           @blur="searchZipCode('amsCustomerDetail.beneficOwnerZipcode3',
                                                            'amsCustomerDetail.beneficOwnerPrefecture3',
                                                            'amsCustomerDetail.beneficOwnerCity3')"
                                           required
                                           maxlength="7"
                                           v-convert-fullwidth-to-halfwidth>
                                </div>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerZipcode3'].$anyError"
                                     class="error-messages ng-active">
                                    <div v-if="!$v.input['amsCustomerDetail.beneficOwnerZipcode3'].required">
                                        {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_zipcode' )})}}
                                    </div>
                                    <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode3'].required && !$v.input['amsCustomerDetail.beneficOwnerZipcode3'].customerNumberValidation">
                                        {{$t('profile.error.invalid_number')}}
                                    </div>
                                </div>
                            </div>
                            <label class="col-md-3">
                                <a :href="hrefPostalCodeReference" target="_blank">{{$t('profile.href.postal_code_reference')}}</a>
                            </label>
                        </div>

                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_prefecture')}}</label>
                            <div class="col-md-6">
                                <select v-if="isVisible" class="form-control">
                                    <option selected>*****</option>
                                </select>
                                <select
                                    v-else
                                    class="form-control"
                                    v-model="$v.input['amsCustomerDetail.beneficOwnerPrefecture3'].$model"
                                    required
                                    name="beneficOwnerPrefecture3"
                                >
                                    <option v-for="item in listPrefecture" :key="item.key" :value="item.key">
                                        {{item.value}}
                                    </option>
                                </select>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerPrefecture3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerPrefecture3'].$anyError"
                                     class="error-messages ng-active">
                                    <div v-if="!$v.input['amsCustomerDetail.beneficOwnerPrefecture3'].required">
                                        {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_prefecture' )})}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_city')}}</label>
                            <div class="col-md-6">
                                <template v-if="isVisible">
                                    <input type="text"
                                           class="form-control"
                                           value="*****"
                                           name="beneficOwnerCity3"
                                           required
                                           maxlength="100"
                                           v-convert-halfwidth-to-fullwidth
                                    >
                                </template>
                                <template v-else>
                                    <input type="text"
                                           class="form-control"
                                           v-model="$v.input['amsCustomerDetail.beneficOwnerCity3'].$model"
                                           name="beneficOwnerCity3"
                                           required
                                           maxlength="100"
                                           v-convert-halfwidth-to-fullwidth
                                    >
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerCity3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerCity3'].$anyError"
                                     class="error-messages ng-active">
                                    <div v-if="!$v.input['amsCustomerDetail.beneficOwnerCity3'].required">
                                        {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_city')})}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_section')}}</label>
                            <div class="col-md-6">
                                <template v-if="isVisible">
                                    <input type="text"
                                           class="form-control"
                                           value="*****"
                                           name="beneficOwnerSection2"
                                           required
                                           maxlength="50"
                                           v-convert-halfwidth-to-fullwidth
                                    >
                                </template>
                                <template v-else>
                                    <input type="text"
                                           class="form-control"
                                           v-model="$v.input['amsCustomerDetail.beneficOwnerSection3'].$model"
                                           name="beneficOwnerSection2"
                                           required
                                           maxlength="50"
                                           v-convert-halfwidth-to-fullwidth
                                    >
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerSection3'].$dirty && $v.input['amsCustomerDetail.beneficOwnerSection3'].$anyError"
                                     class="error-messages ng-active">
                                    <div v-if="!$v.input['amsCustomerDetail.beneficOwnerSection3'].required">
                                        {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owener_section' )})}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_building_name')}}</label>
                            <div class="col-md-6">
                                <template v-if="isVisible">
                                    <input type="text" class="form-control"
                                           value="*****"
                                           name="beneficOwnerBuildingName3"
                                           maxlength="50"
                                           v-convert-halfwidth-to-fullwidth
                                    >
                                </template>
                                <template v-else>
                                    <input type="text" class="form-control"
                                           v-model.trim="$v.input['amsCustomerDetail.beneficOwnerBuildingName3'].$model"
                                           name="beneficOwnerBuildingName3"
                                           maxlength="50"
                                           v-convert-halfwidth-to-fullwidth
                                    >
                                </template>
                            </div>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner4')}}</label>
                          <div class="col-md-6">
                            <div class="form-check form-check-inline" v-for="beneficOwner in listBeneficOwnerOtherOne" :key="beneficOwner.key">
                              <input class="form-check-input"
                                     type="radio"
                                     name="inlineRadioOptions_4"
                                     :id="'inlineRadioOptions_4'+beneficOwner.key"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerFlg4'].$model"
                                     :value="beneficOwner.key">
                              <label class="form-check-label" :for="beneficOwner.value">{{beneficOwner.value}}</label>
                            </div>
                          </div>
                        </div>
                      <div class="benefic-info" v-if="input['amsCustomerDetail.beneficOwnerFlg4'] === '1'">
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label" style="font-weight: bold;">{{$t('profile.benefic.label.title.4')}}</label>
                        </div>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_type')}}</label>
                          <div class="col-md-6">
                            <div class="form-check form-check-inline" v-for="beneficOwnertype in listBeneficOwnerType"
                                 :key="beneficOwnertype.key">
                              <input class="form-check-input"
                                     type="radio"
                                     name="inlineRadioType4Options"
                                     :id="'inlineRadioType4Options_' + beneficOwnertype.value"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerType4'].$model"
                                     :value="beneficOwnertype.key"
                              >
                              <label class="form-check-label" :for="beneficOwnertype.value">{{beneficOwnertype.value}}</label>
                            </div>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerType4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerType4'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerType4'].beneficOwnerTypeRequiredValidation">
                                {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_type') })}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <template v-if="input['amsCustomerDetail.beneficOwnerType4'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || input['amsCustomerDetail.beneficOwnerType4'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED">
                          <template v-if="(this.isOldBeneficOwner('4') || input['amsCustomerDetail.beneficOwnerType4'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL)">
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerLastName4"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </template>
                                <template v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerLastName4'].$model"
                                         name="beneficOwnerLastName4"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastName4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastName4'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastName4'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name')}}</label>
                              <div class="col-md-6">
                                <div v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerFirstName4"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </div>
                                <div v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerFirstName4'].$model"
                                         name="beneficOwnerFirstName4"
                                         required
                                         maxlength="40"
                                         v-convert-halfwidth-to-fullwidth>
                                </div>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstName4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstName4'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstName4'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_last_name_kana')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerLastNameKana4"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <template v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerLastNameKana4'].$model"
                                         name="beneficOwnerLastNameKana"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerLastNameKana4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerLastNameKana4'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerLastNameKana4'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_last_name_kana') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_first_name_kana')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text"
                                         class="form-control"
                                         value="*****"
                                         name="beneficOwnerFirstNameKana4"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <template v-else>
                                  <input type="text"
                                         class="form-control"
                                         v-model="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana4'].$model"
                                         name="beneficOwnerFirstNameKana4"
                                         required
                                         maxlength="40"
                                         v-special-characters-validator
                                         v-convert-kana-word>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerFirstNameKana4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFirstNameKana4'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFirstNameKana4'].required">
                                    {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_first_name_kana') })}}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_establish_date')}}</label>
                              <div class="col-md-6">
                                <template v-if="isVisible">
                                  <input type="text" value="****/**/**" class="form-control">
                                  <span class="btn-datepicker">
                                        	<i class="icon-calendar icons"/>
                                     	</span>
                                </template>
                                <template v-else>
                                  <trs-date-picker :hasIcon="true" v-model="$v.input['amsCustomerDetail.beneficOwnerEstablishDate4'].$model"/>
                                </template>
                                <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerEstablishDate4'].$anyError"
                                     class="error-messages ng-active">
                                  <div v-if="!$v.input['amsCustomerDetail.beneficOwnerEstablishDate4'].required">
                                    {{$t('MSG_TRS_NAF_0126')}}
                                  </div>
                                  <div v-if="$v.input['amsCustomerDetail.beneficOwnerEstablishDate4'].required && !$v.input['amsCustomerDetail.beneficOwnerEstablishDate4'].validDate">
                                    <div>{{$t('MSG_TRS_NAF_0126')}}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name')}}</label>
                            <div class="col-md-6">
                              <template v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerFullname4"
                                       required
                                       maxlength="40"
                                       v-convert-halfwidth-to-fullwidth>
                              </template>
                              <template v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerFullname4'].$model"
                                       name="beneficOwnerFullname4"
                                       required
                                       maxlength="40"
                                       v-convert-halfwidth-to-fullwidth>
                              </template>
                              <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullname4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullname4'].$anyError"
                                   class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullname4'].required">
                                  {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name') })}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group row">
                            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_name_kana')}}</label>
                            <div class="col-md-6">
                              <template v-if="isVisible">
                                <input type="text"
                                       class="form-control"
                                       value="*****"
                                       name="beneficOwnerFullnameKana4"
                                       required
                                       v-special-characters-validator
                                       maxlength="40"
                                       v-convert-kana-word
                                >
                              </template>
                              <template v-else>
                                <input type="text"
                                       class="form-control"
                                       v-model="$v.input['amsCustomerDetail.beneficOwnerFullnameKana4'].$model"
                                       name="beneficOwnerFullnameKana4"
                                       required
                                       v-special-characters-validator
                                       maxlength="40"
                                       v-convert-kana-word
                                >
                              </template>
                              <div v-if="$v.input['amsCustomerDetail.beneficOwnerFullnameKana4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerFullnameKana4'].$anyError"
                                   class="error-messages ng-active">
                                <div v-if="!$v.input['amsCustomerDetail.beneficOwnerFullnameKana4'].required">
                                  {{$t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.benefic_name_kana')})}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_zipcode')}}</label>
                          <div class="col-md-6">
                            <div v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerZipcode4"
                                     required
                                     maxlength="7"
                                     v-convert-fullwidth-to-halfwidth>
                            </div>
                            <div v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerZipcode4'].$model"
                                     name="beneficOwnerZipcode4"
                                     @blur="searchZipCode('amsCustomerDetail.beneficOwnerZipcode4',
                                                            	'amsCustomerDetail.beneficOwnerPrefecture4',
                                                            	'amsCustomerDetail.beneficOwnerCity4')"
                                     required
                                     maxlength="7"
                                     v-convert-fullwidth-to-halfwidth>
                            </div>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerZipcode4'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerZipcode4'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_zipcode' )})}}
                              </div>
                              <div v-if="$v.input['amsCustomerDetail.beneficOwnerZipcode4'].required && !$v.input['amsCustomerDetail.beneficOwnerZipcode4'].customerNumberValidation">
                                {{$t('profile.error.invalid_number')}}
                              </div>
                            </div>
                          </div>
                          <label class="col-md-3">
                            <a :href="hrefPostalCodeReference" target="_blank">{{$t('profile.href.postal_code_reference')}}</a>
                          </label>
                        </div>

                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_prefecture')}}</label>
                          <div class="col-md-6">
                            <select v-if="isVisible" class="form-control">
                              <option selected>*****</option>
                            </select>
                            <select
                                v-else
                                class="form-control"
                                v-model="$v.input['amsCustomerDetail.beneficOwnerPrefecture4'].$model"
                                required
                                name="beneficOwnerPrefecture4"
                            >
                              <option v-for="item in listPrefecture" :key="item.key" :value="item.key">
                                {{item.value}}
                              </option>
                            </select>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerPrefecture4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerPrefecture4'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerPrefecture4'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_prefecture' )})}}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owner_city')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerCity4"
                                     required
                                     maxlength="100"
                                     v-convert-halfwidth-to-fullwidth
                              >
                            </template>
                            <template v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerCity4'].$model"
                                     name="beneficOwnerCity4"
                                     required
                                     maxlength="100"
                                     v-convert-halfwidth-to-fullwidth
                              >
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerCity4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerCity4'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerCity4'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owner_city')})}}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_section')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text"
                                     class="form-control"
                                     value="*****"
                                     name="beneficOwnerSection4"
                                     required
                                     maxlength="50"
                                     v-convert-halfwidth-to-fullwidth
                              >
                            </template>
                            <template v-else>
                              <input type="text"
                                     class="form-control"
                                     v-model="$v.input['amsCustomerDetail.beneficOwnerSection4'].$model"
                                     name="beneficOwnerSection4"
                                     required
                                     maxlength="50"
                                     v-convert-halfwidth-to-fullwidth
                              >
                            </template>
                            <div v-if="$v.input['amsCustomerDetail.beneficOwnerSection4'].$dirty && $v.input['amsCustomerDetail.beneficOwnerSection4'].$anyError"
                                 class="error-messages ng-active">
                              <div v-if="!$v.input['amsCustomerDetail.beneficOwnerSection4'].required">
                                {{$t('MSG_TRS_NAF_0004_param' , {param1 : $t('profile.label.benefic_owener_section' )})}}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row">
                          <label class="control-label col-md-3 col-form-label">{{$t('profile.label.benefic_owener_building_name')}}</label>
                          <div class="col-md-6">
                            <template v-if="isVisible">
                              <input type="text" class="form-control"
                                     value="*****"
                                     name="beneficOwnerBuildingName4"
                                     maxlength="50"
                                     v-convert-halfwidth-to-fullwidth
                              >
                            </template>
                            <template v-else>
                              <input type="text" class="form-control"
                                     v-model.trim="$v.input['amsCustomerDetail.beneficOwnerBuildingName4'].$model"
                                     name="beneficOwnerBuildingName4"
                                     maxlength="50"
                                     v-convert-halfwidth-to-fullwidth
                              >
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-warning">
                <div>
                    <span>{{$t('profile.benefic.note.1')}}</span>
                    <a :href="SUPPORT_DOMINATOR_URL" target="_blank">{{$t('profile.label.after_upload_link')}}</a>
                    <span>{{$t('profile.benefic.note.2')}}</span>
                    <br>
                    <span>{{$t('profile.benefic.note.3')}}</span>
                    <a :href="SUPPORT_FORM_URL" target="_blank">{{$t('profile.label.after_upload_link.1')}}</a>
                    <span>{{$t('profile.benefic.note.4')}}</span>
                </div>
            </div>

            <template v-if="this.isParentScreenEditProfile">
                <div class="form-action">
                    <button class="btn btn-sm btn-submit btn-success mr-2"
                            :disabled="isDisabledButtonSubmit && isDisableButtonSubmitBenefitName"
                            :type="this.getButtonType()">
                        {{$t('profile.button.submit')}}
                    </button>
                    <button class="btn btn-default btn-cancel btn-sm"
                            type="button"
                            @click="reverseInput">
                        {{$t('profile.button.cancel')}}
                    </button>
                </div>
            </template>
        </ForceNewsBlockWrapper>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
import {createNamespacedHelpers} from 'vuex';
import {required, requiredUnless} from 'vuelidate/lib/validators';
import formMixin from '@/common/mixins/form';
import {
  beneficOwnerTypeRequiredValidation,
  containOnlySpace,
  customerNumberValidation,
  validDate
} from '@/common/helpers/validation';
import _ from 'lodash';
import * as TYPE from "@/store/modules/dashboard/type";

const {mapGetters: mapForceNewsGetters} = createNamespacedHelpers("forceNews");
const {mapActions: mapDashboardActions} = createNamespacedHelpers("dashboard");

export default {
    name: "UpdateCustomerBeneficName",
    props: {
        isVisible: {
            type: Boolean
        }
    },
    mixins: [formMixin],
    data() {
        const hrefPostalCodeReference = this.IConstants.HREF_POSTAL_CODE_REFERENCE;
        return {hrefPostalCodeReference}
    },
    created() {
        this[TYPE.GET_SERVER_TIME]();
    },
    computed: {
        isDisableButtonSubmitBenefitName() {
            const masterInput = JSON.parse(this.masterInput);
            const pickProperties = [];
            if (this.input['amsCustomerDetail.beneficOwnerFlg'] !== masterInput['amsCustomerDetail.beneficOwnerFlg']) {
                if (this.input['amsCustomerDetail.beneficOwnerFlg'] === '0') {
                    return this.$v.$anyError;
                } else {
                  if (this.input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || this.input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED) {
                    pickProperties.push('amsCustomerDetail.beneficOwnerFirstName',
                        'amsCustomerDetail.beneficOwnerFirstNameKana',
                        'amsCustomerDetail.beneficOwnerLastName',
                        'amsCustomerDetail.beneficOwnerLastNameKana',
                        'amsCustomerDetail.beneficOwnerZipcode',
                        'amsCustomerDetail.beneficOwnerPrefecture',
                        'amsCustomerDetail.beneficOwnerSection',
                        'amsCustomerDetail.beneficOwnerEstablishDate',
                        'amsCustomerDetail.beneficOwnerBuildingName')
                  } else {
                    pickProperties.push('amsCustomerDetail.beneficOwnerFullname',
                        'amsCustomerDetail.beneficOwnerFullnameKana',
                        'amsCustomerDetail.beneficOwnerZipcode',
                        'amsCustomerDetail.beneficOwnerPrefecture',
                        'amsCustomerDetail.beneficOwnerSection',
                        'amsCustomerDetail.beneficOwnerBuildingName')
                  }
                }
            }
            if (this.input['amsCustomerDetail.beneficOwnerFlg2'] !== masterInput['amsCustomerDetail.beneficOwnerFlg2']) {
                if (this.input['amsCustomerDetail.beneficOwnerFlg2'] === '0') {
                    return this.$v.$anyError;
                } else {
                  if (this.input['amsCustomerDetail.beneficOwnerType2'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || this.input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED) {
                    pickProperties.push('amsCustomerDetail.beneficOwnerFirstName2',
                        'amsCustomerDetail.beneficOwnerFirstNameKana2',
                        'amsCustomerDetail.beneficOwnerLastName2',
                        'amsCustomerDetail.beneficOwnerLastNameKana2',
                        'amsCustomerDetail.beneficOwnerZipcode2',
                        'amsCustomerDetail.beneficOwnerPrefecture2',
                        'amsCustomerDetail.beneficOwnerSection2',
                        'amsCustomerDetail.beneficOwnerEstablishDate2',
                        'amsCustomerDetail.beneficOwnerBuildingName2')
                  } else {
                    pickProperties.push('amsCustomerDetail.beneficOwnerFullname2',
                        'amsCustomerDetail.beneficOwnerFullnameKana2',
                        'amsCustomerDetail.beneficOwnerZipcode2',
                        'amsCustomerDetail.beneficOwnerPrefecture2',
                        'amsCustomerDetail.beneficOwnerSection2',
                        'amsCustomerDetail.beneficOwnerBuildingName2')
                  }
                }
            }
            if (this.input['amsCustomerDetail.beneficOwnerFlg3'] !== masterInput['amsCustomerDetail.beneficOwnerFlg3']) {
                if (this.input['amsCustomerDetail.beneficOwnerFlg3'] === '0') {
                    return this.$v.$anyError;
                } else {
                  if (this.input['amsCustomerDetail.beneficOwnerType3'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || this.input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED) {
                    pickProperties.push('amsCustomerDetail.beneficOwnerFirstName3',
                        'amsCustomerDetail.beneficOwnerFirstNameKana3',
                        'amsCustomerDetail.beneficOwnerLastName3',
                        'amsCustomerDetail.beneficOwnerLastNameKana3',
                        'amsCustomerDetail.beneficOwnerZipcode3',
                        'amsCustomerDetail.beneficOwnerPrefecture3',
                        'amsCustomerDetail.beneficOwnerSection3',
                        'amsCustomerDetail.beneficOwnerEstablishDate3',
                        'amsCustomerDetail.beneficOwnerBuildingName3')
                  } else {
                    pickProperties.push('amsCustomerDetail.beneficOwnerFullname3',
                        'amsCustomerDetail.beneficOwnerFullnameKana3',
                        'amsCustomerDetail.beneficOwnerZipcode3',
                        'amsCustomerDetail.beneficOwnerPrefecture3',
                        'amsCustomerDetail.beneficOwnerSection3',
                        'amsCustomerDetail.beneficOwnerBuildingName3')
                  }
                }
            }
          if (this.input['amsCustomerDetail.beneficOwnerFlg4'] !== masterInput['amsCustomerDetail.beneficOwnerFlg4']) {
            if (this.input['amsCustomerDetail.beneficOwnerFlg4'] === '0') {
              return this.$v.$anyError;
            } else {
              if (this.input['amsCustomerDetail.beneficOwnerType4'] === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || this.input['amsCustomerDetail.beneficOwnerType'] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED) {
                pickProperties.push('amsCustomerDetail.beneficOwnerFirstName4',
                    'amsCustomerDetail.beneficOwnerFirstNameKana4',
                    'amsCustomerDetail.beneficOwnerLastName4',
                    'amsCustomerDetail.beneficOwnerLastNameKana4',
                    'amsCustomerDetail.beneficOwnerZipcode4',
                    'amsCustomerDetail.beneficOwnerPrefecture4',
                    'amsCustomerDetail.beneficOwnerSection4',
                    'amsCustomerDetail.beneficOwnerEstablishDate4',
                    'amsCustomerDetail.beneficOwnerBuildingName4')
              } else {
                pickProperties.push('amsCustomerDetail.beneficOwnerFullname4',
                    'amsCustomerDetail.beneficOwnerFullnameKana4',
                    'amsCustomerDetail.beneficOwnerZipcode4',
                    'amsCustomerDetail.beneficOwnerPrefecture4',
                    'amsCustomerDetail.beneficOwnerSection4',
                    'amsCustomerDetail.beneficOwnerBuildingName4')
              }
                }
            }
            const masterInputClone = _.cloneDeep(_.pick(masterInput, pickProperties));
            const inputClone = _.cloneDeep(_.pick(this.input, pickProperties));
            const hasNotChange = JSON.stringify(masterInputClone) === JSON.stringify(inputClone);
            return hasNotChange || this.$v.$anyError;
        },
        SUPPORT_DOMINATOR_URL() {
            return this.$store.state[this.namespace].SUPPORT_DOMINATOR_URL
        },
        SUPPORT_FORM_URL() {
          return this.$store.state[this.namespace].SUPPORT_FORM_URL
        },
        SUPPORT_DOCUMENT_URL() {
            return this.$store.state[this.namespace].SUPPORT_DOCUMENT_URL
        },
        listBeneficOwner() {
            return this.IConstants.listBeneficOwner
        },
        listBeneficOwnerType() {
          return this.IConstants.listBeneficOwnerType
        },
        listBeneficOwnerOtherOne() {
            return this.IConstants.listBeneficOwnerOtherOne
        },
        ...mapForceNewsGetters(['listPrefecture'])
    },
    methods: {
        ...mapDashboardActions([
          TYPE.GET_SERVER_TIME
        ]),
        isOldBeneficOwner(beneficOwnerNumber) {
          const masterInput = JSON.parse(this.masterInput);
          return masterInput[`amsCustomerDetail.beneficOwnerFlg${beneficOwnerNumber}`] === '1' &&
              this.input[`amsCustomerDetail.beneficOwnerType${beneficOwnerNumber}`] === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED;
        },

        isDisabledRadio(key) {
          const masterInput = JSON.parse(this.masterInput);
          return masterInput['amsCustomerDetail.beneficOwnerFlg'] === '1' && key === '0';
        },

        searchZipCode: async function (zipCodeKey, prefectureKey, cityKey) {
            const params = {
                'zipCode': this.input[zipCodeKey]
            };
            const response = await this.$service.getService("forceNews").searchZipCode(params);
            if (response) {
                this.input[prefectureKey] = response.prefecture;
                this.input[cityKey] = response.city + '　' + response.section;
                this.$v.$touch();
            }
        },
        buildBeneficOwnerByType(beneficOwnerFlg, beneficOwnerType, beneficOwnerNumber) {
          let beneficOwnerName = {};

          if (beneficOwnerFlg === "1") {
            if (beneficOwnerType === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL || beneficOwnerType === this.IConstants.BENEFIC_OWNER_TYPE.UNDEFINED) {
              beneficOwnerName = {
                [`amsCustomerDetail.beneficOwnerFirstName${beneficOwnerNumber}`]: {},
                [`amsCustomerDetail.beneficOwnerFirstNameKana${beneficOwnerNumber}`]: {},
                [`amsCustomerDetail.beneficOwnerLastName${beneficOwnerNumber}`]: {required},
                [`amsCustomerDetail.beneficOwnerLastNameKana${beneficOwnerNumber}`]: {required},
                [`amsCustomerDetail.beneficOwnerEstablishDate${beneficOwnerNumber}`]: {required, validDate}
              }
            } else {
              beneficOwnerName = {
                [`amsCustomerDetail.beneficOwnerFullname${beneficOwnerNumber}`]: {required},
                [`amsCustomerDetail.beneficOwnerFullnameKana${beneficOwnerNumber}`]: {required},
              }
            }
          } else {
            if (beneficOwnerType === this.IConstants.BENEFIC_OWNER_TYPE.INDIVIDUAL) {
                beneficOwnerName = {
                  [`amsCustomerDetail.beneficOwnerFirstName${beneficOwnerNumber}`]: {},
                  [`amsCustomerDetail.beneficOwnerFirstNameKana${beneficOwnerNumber}`]: {},
                  [`amsCustomerDetail.beneficOwnerLastName${beneficOwnerNumber}`]: {},
                  [`amsCustomerDetail.beneficOwnerLastNameKana${beneficOwnerNumber}`]: {},
                  [`amsCustomerDetail.beneficOwnerEstablishDate${beneficOwnerNumber}`]: {},
                }
            } else {
              beneficOwnerName = {
                [`amsCustomerDetail.beneficOwnerFullname${beneficOwnerNumber}`]: {},
                [`amsCustomerDetail.beneficOwnerFullnameKana${beneficOwnerNumber}`]: {},
              }
            }
          }

          return beneficOwnerName;
        },
        buildBeneficOwnerTypeValidation(beneficOwnerNumber) {
          if (this.isOldBeneficOwner(beneficOwnerNumber)) {
            return {};
          }

          return {beneficOwnerTypeRequiredValidation};
        }
    },
    validations() {
      const beneficOwnerFlg = this.input['amsCustomerDetail.beneficOwnerFlg'];

      const beneficOwnerType = this.input['amsCustomerDetail.beneficOwnerType'];
      const beneficOwnerType2 = this.input['amsCustomerDetail.beneficOwnerType2'];
      const beneficOwnerType3 = this.input['amsCustomerDetail.beneficOwnerType3'];
      const beneficOwnerType4 = this.input['amsCustomerDetail.beneficOwnerType4'];

      let inputbeneficOwner1 = {};
      let inputbeneficOwner2 = {};
      let inputbeneficOwner3 = {};
      let inputbeneficOwner4 = {};

      let result = {};

      //YES: "1", NONE: "0"
      if (beneficOwnerFlg === "1") {
        let beneficOwnerZipCodeValidation;

        if (this.isParentScreenEditProfile) {
          beneficOwnerZipCodeValidation = {
            required: requiredUnless(containOnlySpace),
            customerNumberValidation
          }
        } else {
          beneficOwnerZipCodeValidation = {
            required,
            customerNumberValidation
          }
        }

        inputbeneficOwner1 = {
          'amsCustomerDetail.beneficOwnerFlg':{},
          'amsCustomerDetail.beneficOwnerFlg2': {},
          'amsCustomerDetail.beneficOwnerFlg3': {},
          'amsCustomerDetail.beneficOwnerFlg4': {},

          'amsCustomerDetail.beneficOwnerType': this.buildBeneficOwnerTypeValidation(''),
          'amsCustomerDetail.beneficOwnerZipcode': beneficOwnerZipCodeValidation,
          'amsCustomerDetail.beneficOwnerPrefecture': {
            required,
          },
          'amsCustomerDetail.beneficOwnerCity': {
            required
          },
          'amsCustomerDetail.beneficOwnerSection': {
            required
          },
          'amsCustomerDetail.beneficOwnerBuildingName': {}
        };
        inputbeneficOwner2 = {
          'amsCustomerDetail.beneficOwnerType2': this.buildBeneficOwnerTypeValidation('2'),
          'amsCustomerDetail.beneficOwnerZipcode2': beneficOwnerZipCodeValidation,
          'amsCustomerDetail.beneficOwnerPrefecture2': {
            required,
          },
          'amsCustomerDetail.beneficOwnerCity2': {
            required
          },
          'amsCustomerDetail.beneficOwnerSection2': {
            required
          },
          'amsCustomerDetail.beneficOwnerBuildingName2': {}
        };
        inputbeneficOwner3 = {
          'amsCustomerDetail.beneficOwnerType3': this.buildBeneficOwnerTypeValidation('3'),
          'amsCustomerDetail.beneficOwnerZipcode3': beneficOwnerZipCodeValidation,
          'amsCustomerDetail.beneficOwnerPrefecture3': {
            required,
          },
          'amsCustomerDetail.beneficOwnerCity3': {
            required
          },
          'amsCustomerDetail.beneficOwnerSection3': {
            required
          },
          'amsCustomerDetail.beneficOwnerBuildingName3': {}
        };
        inputbeneficOwner4 = {
          'amsCustomerDetail.beneficOwnerType4': this.buildBeneficOwnerTypeValidation('4'),
          'amsCustomerDetail.beneficOwnerZipcode4': beneficOwnerZipCodeValidation,
          'amsCustomerDetail.beneficOwnerPrefecture4': {
            required,
          },
          'amsCustomerDetail.beneficOwnerCity4': {
            required
          },
          'amsCustomerDetail.beneficOwnerSection4': {
            required
          },
          'amsCustomerDetail.beneficOwnerBuildingName4': {}
        };

        inputbeneficOwner1 = {...inputbeneficOwner1, ...this.buildBeneficOwnerByType('1', beneficOwnerType, '')}
      } else {
        inputbeneficOwner1 = {
          'amsCustomerDetail.beneficOwnerFlg':{},
          'amsCustomerDetail.beneficOwnerFlg2': {},
          'amsCustomerDetail.beneficOwnerFlg3': {},
          'amsCustomerDetail.beneficOwnerFlg4': {},
          'amsCustomerDetail.beneficOwnerType': {},
          'amsCustomerDetail.beneficOwnerType2': {},
          'amsCustomerDetail.beneficOwnerType3': {},
          'amsCustomerDetail.beneficOwnerType4': {},
          'amsCustomerDetail.beneficOwnerZipcode': {},
          'amsCustomerDetail.beneficOwnerPrefecture': {},
          'amsCustomerDetail.beneficOwnerCity': {},
          'amsCustomerDetail.beneficOwnerSection': {},
          'amsCustomerDetail.beneficOwnerBuildingName': {}
        };
        inputbeneficOwner2 = {
          'amsCustomerDetail.beneficOwnerZipcode2': {},
          'amsCustomerDetail.beneficOwnerPrefecture2': {},
          'amsCustomerDetail.beneficOwnerCity2': {},
          'amsCustomerDetail.beneficOwnerSection2': {},
          'amsCustomerDetail.beneficOwnerBuildingName2': {}
        };
        inputbeneficOwner3 = {
          'amsCustomerDetail.beneficOwnerZipcode3': {},
          'amsCustomerDetail.beneficOwnerPrefecture3': {},
          'amsCustomerDetail.beneficOwnerCity3': {},
          'amsCustomerDetail.beneficOwnerSection3': {},
          'amsCustomerDetail.beneficOwnerBuildingName3': {}
        };
        inputbeneficOwner4 = {
          'amsCustomerDetail.beneficOwnerZipcode4': {},
          'amsCustomerDetail.beneficOwnerPrefecture4': {},
          'amsCustomerDetail.beneficOwnerCity4': {},
          'amsCustomerDetail.beneficOwnerSection4': {},
          'amsCustomerDetail.beneficOwnerBuildingName4': {}
        };

        inputbeneficOwner1 = {...inputbeneficOwner1, ...this.buildBeneficOwnerByType('0', beneficOwnerType, '')}
      }

      result = {...inputbeneficOwner1};
      if (this.input['amsCustomerDetail.beneficOwnerFlg2'] == '1') {
        inputbeneficOwner2 = {...inputbeneficOwner2, ...this.buildBeneficOwnerByType('1', beneficOwnerType2, '2')}
        result = {...result, ...inputbeneficOwner2}
        if (this.input['amsCustomerDetail.beneficOwnerFlg3'] == '1') {
          inputbeneficOwner3 = {...inputbeneficOwner3, ...this.buildBeneficOwnerByType('1', beneficOwnerType3, '3')}
          result = {...result, ...inputbeneficOwner3}
          if (this.input['amsCustomerDetail.beneficOwnerFlg4'] == '1') {
            inputbeneficOwner4 = {...inputbeneficOwner4, ...this.buildBeneficOwnerByType('1', beneficOwnerType4, '4')}
            result = {...result, ...inputbeneficOwner4}
          } else {
            result = {...result}
          }
        }
        else {
          result = {...result}
        }
      } else {
        result = {...result};
      }

      return {
        input: {
          ...result
        },
      }
    },
}
</script>
<style scoped>
.form-group {
  margin-bottom: 5px;
  padding-bottom: 15px;
}
.btn-datepicker {
  justify-content: center;
  align-items: center;
  padding: 7px 12px;
  font-size: 14px;
  font-weight: normal;
  background-color: #eeeeee;
  border: 1px solid #cccccc;
  border-left: none;
}
</style>

